import { Header, PortalApp } from "@wexinc/wex-common-web";
import { GearIcon, LinkButton } from "@wexinc/wex-ui";
import { useNavigate } from "react-router-dom";
import { useCopSecurityService } from "services/security";
import { CopAdminRoutes, CopRoutes } from "app/routes";
import { addQuerystringParam } from "util/url-helper";
import useCOPOrganizationService from "services/organization";
import useCopPortalAppService from "services/portal-app";

const AppHeader = () => {
  const portalAppService = useCopPortalAppService();
  const portalApps = portalAppService.getPortalApps();
  const navigate = useNavigate();
  const copSecurityService = useCopSecurityService();
  const copOrganizationService = useCOPOrganizationService();

  const additionalContent = (
    <LinkButton
      testId="organizations"
      to={`/${CopRoutes.admin}/${CopAdminRoutes.organizations}`}
    >
      <GearIcon className="fill-current mr-2" />
      Administration
    </LinkButton>
  );

  function mutatePortalApp(portalApp: PortalApp) {
    const result = { ...portalApp };
    let url: string | undefined;
    const currentOrgId = copOrganizationService.getCurrentOrganizationId();
    if (result.url) {
      url = currentOrgId ? addQuerystringParam(result.url!, "organizationId", currentOrgId) : result.url;
    }
    result.url = url;

    return result;
  }

  const filteredPortalApps = portalApps.filter((app) => app.url !== "#");

  return (
    <Header
      appDisplayName="Customer Operations Portal"
      portalApps={filteredPortalApps}
      logout={() => copSecurityService.logout()}
      onAppHomeClick={() => navigate(CopRoutes.root)}
      additionalHeaderContent={additionalContent}
      loggedInUser={copSecurityService.securityStore.loggedInUser}
      mutatePortalApp={mutatePortalApp}
    ></Header>
  );
};

export default AppHeader;